/**
 * Application route constants
 * 
 * Centralized location for all route paths used in the application
 */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CUSTOMERS: '/customers',
  CUSTOMER_DETAIL: '/customers/:id',
  CUSTOMER_NEW: '/customers/new',
  CUSTOMER_EDIT: '/customers/edit/:id',
  EMPLOYEES: '/employees',
  EMPLOYEE_DETAIL: '/employees/:id',
  EMPLOYEE_NEW: '/employees/new',
  EMPLOYEE_EDIT: '/employees/edit/:id',
  ORDERS: '/orders',
  ORDER_DETAIL: '/orders/:id',
  ORDER_NEW: '/orders/new',
  ORDER_EDIT: '/orders/edit/:id',
  ADVANCED_DELIVERY: '/delivery/advanced',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  NOTIFICATIONS: '/notifications',
  REPORTS: '/reports',
  DELIVERY_REPORT: '/reports/delivery',
  DELIVERY_ADMIN_REPORT: '/reports/delivery/admin',
  ROUTE_ANALYSIS_REPORT: '/reports/route-analysis',
  RANKING_REPORT: '/reports/ranking',
  UPDATES: '/updates',
  UPDATE_NEW: '/updates/new',
  NOT_FOUND: '*'
};

/**
 * Generate a route path with parameters
 * 
 * @param route The route path template with placeholders
 * @param params The parameters to replace in the route
 * @returns The route path with parameters replaced
 */
export const generatePath = (route: string, params: Record<string, string | number>): string => {
  let path = route;
  Object.entries(params).forEach(([key, value]) => {
    path = path.replace(`:${key}`, String(value));
  });
  return path;
};

export default ROUTES; 